var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQueriesProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.518,
    height: 20.484,
    viewBox: "0 0 18.518 20.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d",
    "data-name": "vmUhUD.tif"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.518,6.586c-.05.178-.094.535-.247.836-.339.666-.684,1.339-1.116,1.946-.955,1.344-2.281,2.131-3.911,2.395-.166.027-.335.048-.503.058-.511.031-.6.178-.383.631.761,1.586.868,3.218.181,4.838-.339.799-.799,1.56-1.296,2.275-.68.978-2.001,1.189-3.087.567-1.711-.979-3.417-1.968-5.124-2.953-.603-.348-1.209-.69-1.807-1.045-1.194-.709-1.575-2.084-.878-3.282.475-.817.858-1.695,1.54-2.383,1.095-1.105,2.414-1.707,3.964-1.807.405-.026.508-.21.323-.588-.752-1.536-.901-3.131-.26-4.717.352-.87.847-1.702,1.39-2.472.685-.971,1.993-1.144,3.099-.511,1.619.927,3.233,1.864,4.849,2.797.694.401,1.393.792,2.08,1.205.765.46,1.147,1.152,1.186,2.211ZM2.036,14.027c-.02.021-.04.042-.059.063.125.12.233.271.379.356,2.233,1.297,4.47,2.586,6.708,3.876.377.217.485.187.708-.192.08-.136.163-.271.238-.41.255-.472.58-.921.745-1.423.343-1.044.21-2.075-.264-3.072-.142-.298-.25-.636-.27-.962-.08-1.31.92-2.366,2.234-2.46,1.422-.101,2.568-.69,3.276-1.989.192-.352.401-.693.601-1.041.236-.41.207-.518-.199-.753-2.154-1.243-4.309-2.486-6.464-3.73-.668-.386-.674-.389-1.053.286-.299.532-.662,1.045-.856,1.614-.363,1.064-.213,2.12.297,3.125.754,1.486-.302,3.288-1.967,3.361-.893.039-1.684.343-2.393.882-.817.62-1.127,1.584-1.646,2.407-.01.017-.009.041-.012.062Z",
    fill: "#bababa"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueriesProgress);
export default __webpack_public_path__ + "static/media/QueriesProgress.1fb2ec76.svg";
export { ForwardRef as ReactComponent };